import type { FaireProductEntity } from "../../entity_types/product";

export const p_kxshwxzjhj: FaireProductEntity = {
  token: "p_kxshwxzjhj",
  type: "product",
  name: "M7876-SW CALIFORNIA graphic  sweatshirts",
  brandToken: "b_7t768kwdvz",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4bb5daed5f25a08bed235908e242068abc67997829186fa956ff8b7d6dc80c81.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4719e6a3e2a878ef63325b1970f72f0e2488bfa41184f782984b28f0c5eac3a8.jpeg",
    "https://cdn.faire.com/fastly/fd3f5f33b5aaab0748213ceaf7c1c5615785d218a36d8bd3576060ea8fa73764.jpeg",
    "https://cdn.faire.com/fastly/a04b2111c51f36c4b076fd5c89ed53a4c71499deae548842bbc2603d4bcaf0f2.jpeg",
    "https://cdn.faire.com/fastly/225de53430568dc9a48768803d7950ee8a91b6d1b3f5c1834b666537bf54a1c6.jpeg",
  ],
  priceDollars: 27.65,
  description:
    "This unisex tee is made of very soft cotton. The double stitching on the neckline and sleeves add more durability to what is sure to be a favorite!\nFeatures: Mid-weight Fleece \nFabrication: 80% Cotton, 20% Poly Ring-Spun Yarn 7.8 oz.\nPrinted in the USA. \n-S-3XL AVAILABLE\n-Other colors are also available\n-Please write it down in the memo when you make a purchase .\n-ECO FRIENDLY INKS",
  tags: [],
  msrpDollars: 55.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:00.702Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
